import Client from "./Client";
// import RequestList from "./RequestList";

const UsersService = {
    url: 'admin/clients',
    getDefault(){
        return {
        }
    },
    /**
     * @params RequestList requestList
     * @return Request Promise
     **/
    async list(requestList) {
        return await Client.get(`${this.url}`, requestList.json());
    }
}

export default UsersService